import {types} from '../../types';

const setGetListPaymentSystemAction = (payload) => {
    return {
        type: types.replenishment.SET_LIST_MOBILE,
        payload,
      }
}

export {
  setGetListPaymentSystemAction as SetGetListPaymentSystemAction,
}